<modal-ore>
    <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div if="{ state.modal_visible }" class="fixed inset-0 bg-gray-500/75 transition-opacity { state.modal_visible ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out ì duration-300' }"></div>
        <div if="{ state.modal_visible }" class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 { state.modal_visible ? 'ease-out duration-300 opacity-100 translate-y-0 sm:scale-100' : 'ease-in duration-200 opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95' }">
                    <form method="POST" onsubmit="{
                                submit
                            }">
                        <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                            <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">Modifica attività</h3>
                            <div class="grid grid-cols-2 gap-4 mt-6">
                                <div class="col-span-1">
                                    <input-text label="Data" ckey="data" autocomplete="off" inputtype="date" value="{ state.data }" is_required="required"></input-text>
                                </div>
                                <div class="col-span-1">
                                    <input-text label="Quantità" ckey="quantita" autocomplete="off" value="{ state.quantita }" is_required="required"></input-text>
                                </div>
                                <div class="col-span-2">
                                    <my-textarea label="Descrizione" ckey="descrizione" autocomplete="off" value="{ state.descrizione }" is_required="required"></my-textarea>
                                </div>
                                <div class="col-span-2">
                                    <my-textarea label="Note" ckey="note" autocomplete="off" value="{ state.note }" is_required="required"></my-textarea>
                                </div>
                                <div class="col-span-2">
                                    <combobox label="Risorsa" ckey="modal_risorsa_ore" value="{ state.id_risorsa }" is_required="required"></combobox>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                            <button type="submit" class="rounded-md bg-cyan-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-cyan-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600">Salva</button>
                            <button type="button" onclick="{
                                        close_modal
                                    }" class="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50">Annulla</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <script>
        import StoreService from '/src/services/store'
        import eventBus from '/src/utils/event-bus'
        import { fetchComboboxRisorse, getIdRisorsa } from '/src/utils/functions'
        import moment from 'moment-with-locales-es6'
        import { EVENTS, KEYS } from '/src/utils/constants'

        export default {

            moment: moment,
            getIdRisorsa: getIdRisorsa,

            onBeforeMount(props, state) {
                this.state = {
                    id: '',
                    id_commessa: props.id_commessa,
                    data: '',
                    quantita: '',
                    descrizione: '',
                    note: '',
                    id_risorsa: '',
                    risorsa: '',
                    modal_visible: false
                }

                eventBus.on(EVENTS.UI.OPEN_MODAL_ORE, this.open_modal)
                eventBus.on(EVENTS.INPUT.UPDATED, this.handleInputChanged)
                eventBus.on(EVENTS.COMBOBOX.SELECTED, this.handleInputChanged)
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.UI.OPEN_MODAL_ORE, this.open_modal)
                eventBus.off(EVENTS.INPUT.UPDATED, this.handleInputChanged)
                eventBus.off(EVENTS.COMBOBOX.SELECTED, this.handleInputChanged)
            },

            handleInputChanged(e) {
                switch (e.ckey) {
                    case "data":
                    case "quantita":
                    case "descrizione":
                    case "note":
                    case "risorsa":
                        this.update({
                            [e.ckey]: e.value
                        })
                        break;
                    case "modal_risorsa_ore":
                        this.update({
                            "risorsa": e.value
                        })
                        break;
                    default:
                        break;
                }
            },

            async submit(e) {
                e.preventDefault()
                const result = await StoreService.saveOra(this.state.id, {
                    commessa: this.state.id_commessa,
                    data: this.state.data,
                    quantita: this.state.quantita,
                    descrizione: this.state.descrizione,
                    note: this.state.note,
                    risorsa: this.state.risorsa
                })
                this.close_modal()
                if (result.success) {
                    eventBus.trigger(EVENTS.ITEMS.REFRESH, {
                        ckey: KEYS.ORE
                    })
                } else {
                    eventBus.trigger(EVENTS.OPEN_MODAL_ERROR, {
                        ckey: "error",
                        title: "Errore nel salvataggio delle ore",
                        text: result.error
                    })
                }
            },

            close_modal() {
                this.update({
                    id: '',
                    id_commessa: '',
                    data: '',
                    quantita: '',
                    descrizione: '',
                    note: '',
                    id_risorsa: '',
                    risorsa: '',
                    modal_visible: false
                })
            },

            open_modal(e) {
                if (e.ckey === this.props.ckey) {
                    fetchComboboxRisorse().then(risorse => {
                        eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                            ckey: 'modal_risorsa_ore',
                            items: risorse
                        });
                    });
                    this.update({
                        id: e.data.id,
                        id_commessa: e.data.id_commessa,
                        data: e.data.data ? e.data.data : moment().format('YYYY-MM-DD'),
                        quantita: e.data.quantita,
                        descrizione: e.data.descrizione,
                        note: e.data.note,
                        id_risorsa: e.data.id_risorsa,
                        risorsa: e.data.risorsa ? e.data.risorsa : this.getIdRisorsa(),
                        modal_visible: true
                    })
                }
            }
        }
    </script>
</modal-ore>
